export enum PromocodeApiTags {
  Promocode = 'Promocode',
  PromocodeUsages = 'ClientPromocodesUsages',
}

export const tagTypes = Object.values(PromocodeApiTags);
